// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2efVi","dragIcon":"Choice_dragIcon__9U1KW","left":"Choice_left__2PgUu","input":"Choice_input__1mVvH"};